(function($){
    var exploreTrigger  = $('.explore_our_services'),
        exploreList     = $('#mgi_services_list'),
        coffeeSection   = $('#coffee_section'),
        overlay         = $('.overlay'),
        close           = $('.mgi_close'),
        matchHeight     = $('.match_height'),
        $header          = $('.header'),
        $body           = $('body'),
        $window         = $(window);

    var openServices = function () {
        exploreList.add(coffeeSection).addClass('open');
        overlay.addClass('open');
        $header.css('z-index', '0');
        $('.below_banner').addClass('open');


        // Check if the Service list is visible
        // if not smoothly scroll up.
        setTimeout(function(){
            var openPosition = $('#mgi_services_list.open').offset().top;

            if( openPosition < $(window).scrollTop() ){

                var target = exploreList;
                if (target.length) {
                    $('html, body').animate({
                        scrollTop: target.offset().top - $('header').height()
                    }, 1000);
                    return false;
                }
            }
        }, 600);
    }

    exploreTrigger.click(openServices);

    close.add(overlay).on('click', function(){
        exploreList.add(coffeeSection).removeClass('open');
        $('body').css('overflow', 'visible');
        overlay.removeClass('open');
        $header.css('z-index', '999');
        $('.below_banner').removeClass('open');
    });

    //    Header background
    if ( $(window).scrollTop() > 10 ) {
        $header.addClass('white');
        $('.contact_page').addClass('top');
    }else{
        $header.removeClass('white');
        $('.contact_page').removeClass('top');
    }

    $(window).on('scroll resize', function(){
        if ( $(window).scrollTop() > 10 ) {
            $('.header').addClass('white');
            $('.contact_page').addClass('top');
        }else{
            $('.header').removeClass('white');
            $('.contact_page').removeClass('top');
        }
    });

    if( matchHeight.length > 0){
        matchHeight.matchHeight();

        $window.on('resize', function(){
            matchHeight.matchHeight();
        });
    } 


    var arrowDown = "<i class='mgi-chevron-down'></i>";
    var hasChildren = $('.menu-item-has-children');
    hasChildren.append(arrowDown);
    var triggerSubmenu = hasChildren.find('.mgi-chevron-down');

    if( $window.width() < 768 ){
        triggerSubmenu.css('display', 'block');
        triggerSubmenu.on('click', function(){
            $(this).toggleClass('mgi-chevron-up');
            $(this).prev().toggleClass('on');
        });
    }else{
        triggerSubmenu.css('display', 'none');
    }

    $window.on('resize', function(){
        if($window.width() < 768 ){
            triggerSubmenu.css('display', 'block');
        }else{
            triggerSubmenu.css('display', 'none');
            $header.removeClass('mobile_menu');
        }
    });


    $('.navbar-toggle').on('click', function(){
        $header.toggleClass('mobile_menu');
    });

    $('.gfield_checkbox').find('label').prepend('<span>');
    $('.gfield_checkbox').find('label').append('</span>');



    $('.banner_intro button').on('click', function(){
        localStorage.setItem("formId", $(this).attr('data-target'));
    });

    if ( $('.validation_error').length > 0 ){
        formToReopen = localStorage.getItem("formId");
        console.log(formToReopen);
        $(formToReopen).modal();
    }
    
    var searchTrigger = $('nav .mgi-search');
    searchTrigger.on('click', function(){
        $(this).toggleClass('current-menu-item');
       $('.search_field').toggleClass('show');
    });

    var youtubePopup = $('.youtube_popup');
    youtubePopup.on('click', function(e){
        e.preventDefault();
        var video = $(this).attr('data-video');
        var iframe = '<iframe src="https://www.youtube.com/embed/'+video+'?autoplay=1" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
        $('#video_modal .video').html(iframe);
        $('#video_modal').modal('show');
    });

    var vimeoPopup = $('.vimeo_popup');
    vimeoPopup.on('click', function(e){
        e.preventDefault();
        var video = $(this).attr('data-video');
        var iframe = '<iframe src="https://player.vimeo.com/video/'+video+'?color=ffffff&portrait=0&autoplay=true" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
        $('#video_modal .video').html(iframe);
        $('#video_modal').modal('show');
    });

    var videoPopup = $('.video_popup');
    videoPopup.on('click', function(e){
        e.preventDefault();
        var video = $(this).attr('data-video');
        var iframe = '<iframe src="'+video+'" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
        $('#video_modal .video').html(iframe);
        $('#video_modal').modal('show');
    });

    var surveyPopup = $('.survey-popup');
    surveyPopup.on('click', function(e){
        e.preventDefault();
        $('#my_survey_modal').modal('show');
    });



    $(function() {
        $('.stories_home .story').matchHeight();
    });

    function msieDetect() {
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE");
        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))
        {
           $('body').addClass('ie')
        }
        return false;
    }
    msieDetect();

})(jQuery);
